import { Monitor, Moon, Sun } from "lucide-react";
import { useTheme, type Theme } from "@/lib/theme";

const ICONS: Record<Theme, typeof Sun> = {
  light: Sun,
  dark: Moon,
  system: Monitor,
};

const NEXT_LABEL: Record<Theme, string> = {
  light: "dark",
  dark: "system",
  system: "light",
};

export function ThemeToggle() {
  const { theme, cycleTheme } = useTheme();
  const Icon = ICONS[theme];

  return (
    <button
      type="button"
      onClick={cycleTheme}
      // The visible icon shows the CURRENT theme, so the accessible name has to
      // say what pressing it does — otherwise a screen reader user can't tell.
      aria-label={`Theme: ${theme}. Switch to ${NEXT_LABEL[theme]}.`}
      title={`Theme: ${theme}`}
      className="inline-flex size-9 items-center justify-center rounded-sm border border-border bg-surface text-muted transition-colors hover:border-border-strong hover:text-text"
    >
      <Icon aria-hidden="true" className="size-4" />
    </button>
  );
}
